function mmAddProductToCartWithPrevention(event, productId, options) {
    event.preventDefault(); 
    event.stopPropagation(); 
    mmAddProductToCart(productId, options); 
}

/*********************************************************************************************
* Initialize the Splide carousel for the cart section.
	*
*/
function mmInitSplideRea() {
    const id = '.splide-reassurance';
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
            type: 'loop',
			autoplay: true,
            arrows: false,
            pagination: true,
            rewind: true,
            gap: 12,
            perPage: 1
        }).mount();
    }
}

function mmInitSplideCross() {
    const id = '.splide-cross-sell';
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
            type: 'slide',
            arrows: false,
            pagination: false,
            rewind: true,
            gap: 12,
            perPage: 1,
            destroy: true,
            breakpoints : {
                768: {
                    destroy  : false,
                    fixedWidth: 260, 
                }
            }
        }).mount();
    }
}

/*********************************************************************************************
* Creates a debounced function that delays invoking func until after duration milliseconds have elapsed since the last time the debounced function was invoked.
	*
	* @param {Function} func - The function to debounce.
	* @param {number} duration - The number of milliseconds to delay.
	* @returns {Function} - The debounced function.
*/
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

/*********************************************************************************************
* Get the full cart section ID from the DOM.
	*
	* @returns {HTMLElement} - The full cart section ID with the prefix.
*/
function mmCartSectionIdLong() {
	return document.querySelector('.mm-cart').id;
}

/*********************************************************************************************
* Get the cart section ID from the DOM, removing the "shopify-section-" prefix.
	*
	* @returns {HTMLElement} - The cart section ID without the "shopify-section-" prefix.
*/
function mmCartSectionId() {
	return document.querySelector('.mm-cart').id.replace('shopify-section-', '');
}

/*********************************************************************************************
* Get the cart section element from the DOM.
	*
	* @returns {HTMLElement} - The cart section element.
*/
function mmCartSectionElement() {
    return document.getElementById(`${mmCartSectionIdLong()}`);
}

/*********************************************************************************************
* Get the cart product container element from the cart section.
	*
	* @returns {HTMLElement} - The cart product container element.
*/
function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector('.mm-dc-products-container');
}

/*********************************************************************************************
* Get the cart item element for a specific product variant.
	*
	* @param {number} line_index - The line item index.
	* @returns {HTMLElement} - The cart item element.
*/
function mmCartItem(line_index) {
    return mmCartProductsContainerElement().querySelector(`[data-line-index="${line_index}"]`);
}

/*********************************************************************************************
* Get the cart item quantity element for a specific product variant.
	*
	* @param {number} line_index - The line item index.
	* @returns {HTMLElement} - The cart item quantity element.
*/
function mmCartItemQuantityEl(line_index) {
    const itemEl = mmCartItem(line_index);
    return itemEl.querySelector('[data-item-quantity]');
}

/*********************************************************************************************
* Get the quantity of a specific cart item.
	*
	* @param {number} line_index - The line item index.
	* @returns {number} - The quantity of the cart item.
*/
function mmGetCartItemQuantity(line_index) {
    const quantityEl = mmCartItemQuantityEl(line_index);
    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

/*********************************************************************************************
* Set the quantity of a specific cart item and update the DOM.
	*
	* @param {number} line_index - The line item index.
	* @param {number} newQuantity - The new quantity to set.
*/
function mmSetCartItemQuantity(line_index, newQuantity) {
    // Display quantity in front
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(line_index);
        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;
    }
}

/*********************************************************************************************
* Create a new cart element from the provided data.
	*
	* @param {Object} data - The data containing cart HTML.
	* @returns {HTMLElement} - The new cart element.
*/
function mmCartHTMLFromData(data) {
    const el = document.createElement('DIV');
    el.innerHTML = data.sections['mm-cart'];
    return el;
}

/*********************************************************************************************
* Extract the items container from the new cart HTML.
	*
	* @param {Object} data - The data containing cart HTML.
	* @returns {HTMLElement} - The items container element.
*/
function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector('.mm-dc-products-container');
}

/*********************************************************************************************
* Insert cart products from the response data into the current cart in the DOM.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;
    return data;
}

/*********************************************************************************************
* Extract the total price element from the new cart HTML.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {HTMLElement} - The total price element.
*/
function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data);
    return cartEl.querySelector('[data-cart-total-price]');
}

/*********************************************************************************************
* Insert the total price from the response data into the current cart in the DOM.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector('[data-cart-total-price]');
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
    return data;
}

/*********************************************************************************************
* Perform an API request to fetch or update cart data.
	*
	* @param {string} method - The HTTP method (GET, POST, etc.).
	* @param {string} path - The API endpoint path.
	* @param {Object} body - The request body data.
	* @returns {Promise<Object>} - A promise resolving to the response data.
*/
function mmAPIRequest(method, path, body) {
    document.querySelector('.mm-dc-products')?.classList?.add('mm-inactive');
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            // mmLog(data);
            document.querySelector('.mm-dc-products')?.classList?.remove('mm-inactive');
            updateCartCount(data.item_count != null ? data.item_count : 0);
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

/*********************************************************************************************
* Fetch the current cart data.
	*
	* @returns {Promise<Object>} - A promise resolving to the cart data.
*/
function mmGetCart() {
    return mmAPIRequest('GET', 'cart.js');
}

/*********************************************************************************************
	* Open the cart drawer and fetch the latest cart data.
*/
function mmOpenCart() {
    mmGetCart();
	const cartFilter = document.querySelector('.mm-drawer-cart-filter');
    const html = document.querySelector('html');
    const filter = document.querySelector('[data-filter]');

    if (!cartFilter || !html || !filter) return;

    cartFilter.classList.add('mm-dc-is-open');

    document.querySelector("html").classList.add("stop-scrolling");

    // Immediately ensure the background filter is active
	heightCart();
	adjustCrossSellHeight();
    showBgFilter();

}

/*********************************************************************************************
* Close the cart drawer and allow page scrolling.
	*
*/
function mmCloseCart() {
    hideBgFilter();
    document.querySelector('.mm-drawer-cart-filter').classList.remove('mm-dc-is-open');
    document.querySelector('html').classList.remove('stop-scrolling');
}

/*********************************************************************************************
* Re-render the cart inner HTML from the response data and initialize Splide carousels.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function refreshCartFromData(data) {
    const newCartEl = document.createElement('DIV');
    newCartEl.innerHTML = data.sections[mmCartSectionId()];
    const innerCart = mmCartSectionElement().querySelector('.mm-drawer-cart-filter');
    innerCart.innerHTML = newCartEl.querySelector('.mm-drawer-cart-filter').innerHTML;
    mmInitSplideRea();
    mmInitSplideCross();
    updateShippingDisplay();
    heightCart();
    adjustCrossSellHeight();
    return data;
}

/*********************************************************************************************
* Add a product to the cart and optionally open the cart drawer.
	*
	* @param {number} productId - The product ID to add.
	* @param {Object} options - Options for adding the product.
	* @param {number} [options.quantity=1] - The quantity to add.
	* @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
*/
function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {
    mmAPIRequest('POST', 'cart/add.js', {
        items: [{ quantity: quantity, id: productId }],
        sections: mmCartSectionId(),
    })
        .then(refreshCartFromData)
        .then(mmAddOrRemoveFreeProducts)
        .then((data) => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
        })
        .catch((error) => {
            alert(error.message)
            mmOpenCart();
            console.log(error);
			location.reload();
        });
}

/*********************************************************************************************
* Increase the quantity of a specific product in the cart by one.
	*
	* @param {number} line_index - The line item index.
*/
function mmIncreaseProductQuantity(line_index) {
    const itemCart = mmCartItem(line_index);
    const quantity = mmGetCartItemQuantity(line_index);
    const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
    const newQuantity = quantity + 1;

    if (newQuantity > maxQtty) {
        return;
    }

    mmSetCartItemQuantity(line_index, newQuantity);
    mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
	* Decrease the quantity of a specific product in the cart by one.
	*
	* @param {number} line_index - The line item index.
*/
function mmDecreaseProductQuantity(line_index) {
    const itemCart = mmCartItem(line_index);
    const quantity = mmGetCartItemQuantity(line_index);
    const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
    const newQuantity = quantity - 1;

    if (newQuantity > maxQtty) {
        return;
    }

    mmSetCartItemQuantity(line_index, newQuantity);
    mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
* Remove a specific product from the cart.
	*
	* @param {number} line_index - The line item index.
*/
function mmDestroyProductFromCart(line_index) {
    const newQuantity = 0;
    mmSetCartItemQuantity(line_index, newQuantity);
    mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
* Push the new quantity of a specific product to the server.
	*
	* @param {number} line_index - The line item index.
*/
function mmPushNewQuantity(line_index) {
    const quantity = mmGetCartItemQuantity(line_index);
    mmAPIRequest('POST', 'cart/change.js', {
        line: line_index,
        quantity: quantity,
        sections: mmCartSectionId(),
    })
	.then(mmAddOrRemoveFreeProducts)
	.then(refreshCartFromData)
	.then((data) => {
	})
	.catch((error) => {
		alert(error.message)
		console.log(error);     
		location.reload();
	})
}

/*********************************************************************************************
* Remove a line item from the cart.
	*
	* @param {number|string} line_index - The index of the line item in the cart to be removed.
*/
function mmDestroyLineItemFromCart(line_index) {
    mmAPIRequest("POST", "cart/change.js", {
        line: parseInt(line_index),
        quantity: 0,
        sections: mmCartSectionId(),
    })
    .then(refreshCartFromData);
}

/*********************************************************************************************
* Debounced function to push new quantity of a specific product to the server.
	*
	* @param {number} line_index - The line item index.
 */
const mmDebouncedPushNewQuantity = debounce(function (line_index, maxQtty) {
	const quantity = mmGetCartItemQuantity(line_index);

    if (quantity > maxQtty) {
        return;
    }
	mmPushNewQuantity(line_index);
}, 300);

/*********************************************************************************************
* Update the cart count bubble with the given value.
	*
	* @param {number} value - The new cart count value.
*/
function updateCartCount(value) {
    if (value > 0) {
        document.querySelector('.mm-cart-count-bubble-container').classList.remove('mm-none');
        document.querySelector('.mm-cart-count-bubble').innerText = value;
    } else {
        document.querySelector('.mm-cart-count-bubble-container').classList.add('mm-none');
    }
}

/*********************************************************************************************
* Add or remove free products from the cart based on conditions.
	*
	* @param {Object} data - The data containing the new cart HTML.
	* @returns {Object} - The response data.
*/
function mmAddOrRemoveFreeProducts(data) {
    if (data.sections['mm-cart']) {
        const el = mmCartHTMLFromData(data);
        const freeProductEls = el.querySelector('[data-free-products]');
        let freeProductCounts = 0;

        // creates an object like { 44058675: 1, 44058001: 0 }
        // where key is free product id and value, its quantity
        const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
            const productId = freeProductEl.dataset.variantId;
            const isFree = freeProductEl.dataset.freeProduct == 'true';
            const itemEl = mmCartItem(productId);
            if (isFree) {
                freeProductCounts += 1;
            }
            if (itemEl && isFree) {
                console.log('do nothing, item is already added');
                // do nothing, item is already added
            } else if (itemEl && !isFree) {
                console.log('item is present but should be removed');
                // item is present but should be removed
                param[productId] = 0;
            } else if (!itemEl && isFree) {
                console.log('item is absent but should be added', productId);
                // item is absent but should be added
                param[productId] = 1;
            }
            return param;
        }, {});

        // Add or remove free products only if needed
        if (Object.keys(productsParams).length > 0) {
            console.log('productsParams', productsParams);
            mmAPIRequest('POST', 'cart/update.js', { updates: productsParams, sections: mmCartSectionId() }).then(refreshCartFromData);
        }
    }
    return data;
}

/*********************************************************************************************
* Add a free product to the cart and optionally open the cart drawer.
	*
	* @param {number} productId - The free product ID to add.
	* @param {Object} options - Options for adding the product.
	* @param {number} [options.quantity=1] - The quantity to add.
	* @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
	* @param {HTMLElement} clickedElem - The element that was clicked to trigger this action.
*/
function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
    // Debounce on the CTA
    clickedElem.innerText = 'AJOUTÉ !';
    clickedElem.classList.add('mm-disabled');

    // Ajouter le free product
    mmAddProductToCart(productId, { openCart: false });
}

/*********************************************************************************************
* Loaded Listenner
	*
*/
window.addEventListener('DOMContentLoaded', (event) => {
    mmGetCart();
});

document.addEventListener('DOMContentLoaded', () => {
	mmInitSplideRea();
	mmInitSplideCross();
    updateShippingDisplay();
    closCartHoverHeader();
    stopScrollingHoverHeader()
},
{ once: true });

/*********************************************************************************************
* Free shipping
	*
*/
function updateShippingDisplay() {
    const parentElement = document.querySelector('[data-success]');
    const shippingFalseElement = document.querySelector('.mm-dc-info-cta-shipping-false');
    const shippingTrueElement = document.querySelector('.mm-dc-info-cta-shipping-true');

    if (parentElement && shippingFalseElement && shippingTrueElement) {
        const isSuccess = parentElement.getAttribute('data-success') === 'true';

        if (isSuccess) {
            // Affiche true et masque false
            shippingTrueElement.style.display = 'flex';
            shippingFalseElement.style.display = 'none';
        } else {
            // Affiche false et masque true
            shippingTrueElement.style.display = 'none';
            shippingFalseElement.style.display = 'flex';
        }
    }
}

/*********************************************************************************************
* Height cart
	*
*/
function heightCart() {
    const cart = document.querySelector("[data-cart]");
    let headerMenu = document.querySelector('.mm-header');
    let headerHeight = headerMenu.offsetHeight;
    let headerMenuTop = headerMenu.getBoundingClientRect().top;

    if (cart) {
        cart.style.height = `calc(var(--doc-height) - (${headerHeight}px + ${headerMenuTop}px) - 24px - 24px)`;
        cart.style.top = `calc((${headerHeight}px + ${headerMenuTop}px))`;
    }
}

/*********************************************************************************************
* Close cart
	*
*/
function closCartHoverHeader() {
    const headerElement = document.querySelector('[data-header]');

    if (headerElement) {
        // Ajoute un écouteur pour le survol (mouseenter)
        headerElement.addEventListener('mouseenter', () => {
            mmCloseCart(); // Active la fonction lors du hover
        });
    }
}

/*********************************************************************************************
 * Hover data-header and its children to stop scrolling
 */
function stopScrollingHoverHeader() {
    const headerElement = document.querySelector('.mm-header-left');

    if (headerElement) {
        headerElement.addEventListener('mouseenter', () => {
            console.log('sorvol');
            document.querySelector("html").classList.add("stop-scrolling");
        });

        headerElement.addEventListener('mouseleave', () => {
            console.log('hors survol');
            document.querySelector("html").classList.remove("stop-scrolling");
        });
    }
}

/*********************************************************************************************
* Height cart mobile
	*
*/
function adjustCrossSellHeight() {
    // Vérifier si la largeur de l'écran est inférieure à 768px
    if (window.innerWidth < 990) {
        const infoCta = document.querySelector('.mm-dc-info-cta');
        const crossSell = document.querySelector('.mm-dc-cross-sell');
        
        if (infoCta && crossSell) {
            const infoCtaHeight = infoCta.getBoundingClientRect().height;
            crossSell.style.bottom = `${infoCtaHeight}px`;
        }
    }
}

function adjustPadding() {
    // Vérifier si la largeur de l'écran est inférieure à 768px
    if (window.innerWidth < 990) {
        const crossSell = document.querySelector('.mm-dc-cross-sell');
        const productsContainer = document.querySelector('.mm-dc-products-container');

        if (crossSell && productsContainer) {
            // Récupérer la hauteur de .mm-dc-cross-sell
            const crossSellHeight = crossSell.getBoundingClientRect().height + 16;

            // Ajouter la hauteur de .mm-dc-cross-sell en padding-bottom à .mm-dc-products-container
            productsContainer.style.paddingBottom = `${crossSellHeight}px`;
        }
    }
}

// Appeler les deux fonctions après que le DOM soit chargé
document.addEventListener('DOMContentLoaded', function() {
    adjustCrossSellHeight();
    adjustPadding();
});

// Réagir aux changements de la taille de la fenêtre
window.addEventListener('resize', function() {
    adjustCrossSellHeight();
    adjustPadding();
});
